import { useContext, forwardRef } from 'react'

import { SignatureContext, ColumnsContext } from '../../../context'

const ResizableSignatureColumn = forwardRef(({ column, onMouseDown, onSort, idx }, ref) => {
  const { signaturesSort } = useContext(SignatureContext)
  const { signaturesTableColumnsWidths } = useContext(ColumnsContext)

  let columnStyle = {
    width: column.value === 'helper' ? '100%' : signaturesTableColumnsWidths[column.value] || 200 
  }

  return (
    <div 
      className={`list-view-table__cell ${column.value === 'title' || column.value === 'helper' ? 'title-col filtered-out' : 'draggable-item'}`} 
      key={idx} 
      style={columnStyle}
      ref={ref}
    >
      {column.value !== 'helper' ? (
        <p onClick={() => onSort(column.value)} className={signaturesSort.value === column.value ? 'sort active-sort' : 'sort'}>
          <span className="material-symbols-outlined icon">{column.icon}</span>
          <span className="text">{column.label}</span>
          {signaturesSort.value === column.value && (
            <>
              {signaturesSort.order === 'desc' && <span className="material-symbols-outlined arrow">arrow_upward</span>}
              {signaturesSort.order === 'asc' && <span className="material-symbols-outlined arrow">arrow_downward</span>}
            </>
          )}
        </p>
      ) : (
        <div>&nbsp;</div>
      )}
      {idx !== 0 && column.value !== 'helper' && <div className="resize-handle" onMouseDown={() => onMouseDown(idx, column.value)}></div>}
      {idx === 1 && <div className="resize-handle resize-handle--before" onMouseDown={() => onMouseDown(0, 'title')}></div>}
    </div>
  )
})

export default ResizableSignatureColumn